// extracted by mini-css-extract-plugin
export var cancelButton = "_p3-5";
export var content = "_p3-3";
export var createButton = "_p3-6";
export var drawerContainer = "_p3-0";
export var footer = "_p3-2";
export var header = "_p3-1";
export var orderFormColumn = "_p3-4";